import { DialogService } from '../services/dialog.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import {
  UnverifiedCustomerDialogComponent,
} from 'src/app/shared-dialogs/unverified-customer-dialog/unverified-customer-dialog.component';
import { WIDTH_560 } from 'src/app/shared/configs/dialog-config';
import { CartSuggestionService } from '../../pay/services/cart-suggestion.service';
import { PaymentService } from '../../pay/services/payment.service';

@Injectable({
  providedIn: 'root',
})
export class CartSuggestionGuard implements CanActivate {
  constructor(
    private cartSuggestionService: CartSuggestionService,
    private paymentService: PaymentService,
    private router: Router,
    private dialogService: DialogService,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot): Observable<UrlTree> | boolean {
    const token = this.cartSuggestionService.getCartSuggestionTokenFromSnapshot(next);
    if (token) {
      return this.paymentService.createCartSuggestionPayment(token).pipe(
        map((id) => this.router.parseUrl(`/liabilities/pay/${id}`)),
        tap(() => this.cartSuggestionService.sendAddToCartAnalyticsEvent()),
        catchError((error) => {
          if (error.status === 417) {
            return this.paymentService.getCreatedPaymentId().pipe(
              map((id) => {
                if (id) {
                  return this.router.parseUrl(`/liabilities/pay/${id}`);
                } else {
                  return this.router.parseUrl(`/liabilities/urgent`);
                }
              }),
            );
          }
          if (error.status === 409 && error.error.errorCode === 'CUSTOMER_CART_LIMIT_REACHED') {
            return this.showUnverifiedCustomerDialog(token);
          }
          throw error;
        }),
      );
    }
    return true;
  }

  private showUnverifiedCustomerDialog(token: string): Observable<any> {
    return this.dialogService
      .open(UnverifiedCustomerDialogComponent, {
        maxWidth: WIDTH_560,
        data: {
          returnPath: this.cartSuggestionService.getCartSuggestionTokenPath(token),
          returnUrl: '/dashboard',
        },
      })
      .afterClosed();
  }
}
